
type SpecifyAfterInitType = {
  any: boolean
}

type SpecifyByPhoneType = {
  verified: boolean
}

type ErrorType = {
  message: string
}

type InitSuccessType = {
  init: true
}

type GotSessionData = {
  [key: string]: string
}

type CodeLinkType = {
  code: string
  link: string
}

type Room = {
  _id: string,
  booking: {
    _id: string
  },
  room: {
    _id: string
  }
}

type RoomType = string

enum States {
  INITIAL = 'Go',
  BOOKED_ID = 'bookedId',
  BY_NAME = 'byName',
  BY_PHONE = 'byPhone',
  BOOKED_ID_CONFIRM = 'bookedIdConfirm',
  BOOKED_CONFIRMED = 'bookedConfirmed',
  SPECIFY_BY_PHONE = 'specifyByPhone',
  SPECIFY_BY_ROOM = 'specifyByRoom',
  SPECIFY_BY_ROOM_AFTER_FULL = 'specifyByRoomAfterFull',
}

export type {
  SpecifyAfterInitType,
  SpecifyByPhoneType,
  ErrorType,
  InitSuccessType,
  GotSessionData,
  CodeLinkType,
  RoomType,
  Room
}

export { States }